import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7413d45c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminLandsHold" }
const _hoisted_2 = { class: "display-2 adminHeadline" }
const _hoisted_3 = { class: "tab-contain" }
const _hoisted_4 = {
  key: 0,
  class: "landHoldMainContainer"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"font-size":"20px"} }, "slette landshold player", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"20px","font-size":"18px"} }, "Er du sikker på at du vil slette?", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Yes")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_11 = { style: {"font-size":"20px"} }
const _hoisted_12 = { class: "editLandsholdModal" }
const _hoisted_13 = { class: "layout gutter--xl" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "flex md6" }
const _hoisted_16 = { class: "flex md6" }
const _hoisted_17 = { class: "flex md6" }
const _hoisted_18 = { class: "flex md6" }
const _hoisted_19 = { class: "flex md6" }
const _hoisted_20 = { class: "flex md6" }
const _hoisted_21 = { class: "row justify--center" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "row justify--center mt-4" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Vælg billede")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Remove Image")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Update")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_29 = { class: "sponsorImageModal" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.5em"} }, "Vælg et billede her", -1))
const _hoisted_31 = { class: "imageFlexBox" }
const _hoisted_32 = ["value"]
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Brug valgte billede")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_36 = { class: "tab-contain" }
const _hoisted_37 = { id: "newlandshold" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "form"
}
const _hoisted_40 = { class: "landsholdform-group" }
const _hoisted_41 = { class: "layout gutter--xl" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "flex md6" }
const _hoisted_44 = { class: "flex md6" }
const _hoisted_45 = { class: "flex md6" }
const _hoisted_46 = { class: "flex md6" }
const _hoisted_47 = { class: "flex md6" }
const _hoisted_48 = { class: "flex md6" }
const _hoisted_49 = { class: "row justify--center" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "row justify--center mt-4" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Vælg billede")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Remove Image")
const _hoisted_55 = { class: "row justify--center mt-4" }
const _hoisted_56 = { class: "flex" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Opret ny Player")
const _hoisted_58 = { class: "sponsorImageModal" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"1.5em"} }, "Vælg et billede her", -1))
const _hoisted_60 = { class: "imageFlexBox" }
const _hoisted_61 = ["value"]
const _hoisted_62 = ["src"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Upload et nyt billede")
], -1))
const _hoisted_64 = { class: "uploadSection mb-4" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Upload nyt billede")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Brug valgte billede")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.msg), 1),
    _createVNode(_component_va_tabs, {
      class: "adminTabs",
      modelValue: _ctx.tabValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
    }, {
      tabs: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger landshold', 'Opret ny landshold'], (title) => {
          return _createVNode(_component_va_tab, {
            key: title,
            name: title
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title), 1)
            ]),
            _: 2
          }, 1032, ["name"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (_ctx.landsHoldsData?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.landsHoldsData, (landsHold) => {
              return (_openBlock(), _createBlock(_component_va_card, {
                class: "landsHoldsContain",
                key: landsHold.id
              }, {
                default: _withCtx(() => [
                  (landsHold.landshold_billede || landsHold.landshold_billede_url)
                    ? (_openBlock(), _createBlock(_component_va_image, {
                        key: 0,
                        src: `${_ctx.imageUrl}${landsHold?.landshold_billede?.url ? landsHold?.landshold_billede?.url : landsHold?.landshold_billede_url}`,
                        alt: "landshold"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_va_image, {
                        key: 1,
                        src: "https://i.stack.imgur.com/l60Hf.png",
                        alt: "landshold"
                      })),
                  _createVNode(_component_va_card_title, { class: "landsHoldCardTitle" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_navn), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "landsHoldCardContent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold.landshold_klub), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_card_content, { class: "landsHoldCardContent" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(landsHold?.landshold_pile), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_va_divider),
                  _createVNode(_component_va_card_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_va_button_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "info",
                            name: "editsponsor",
                            onClick: () => { _ctx.setLandsHoldPlayer(landsHold); _ctx.editLandsholdModal = true }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "danger",
                            name: "deletesponsor",
                            onClick: () => { _ctx.setLandsHoldPlayer(landsHold); _ctx.confirmationModal = true }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_va_modal, {
        modelValue: _ctx.confirmationModal,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmationModal) = $event)),
        "hide-default-actions": "",
        "overlay-opacity": "0.2"
      }, {
        header: _withCtx(() => [
          _hoisted_7
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_va_button, {
            color: "danger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteSelectedLandsHoldPlayer()))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_va_button, {
            color: "secondary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmationModal = false, _ctx.selectedLandsHoldPlayer = null))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_va_modal, {
        modelValue: _ctx.editLandsholdModal,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editLandsholdModal) = $event)),
        "hide-default-actions": "",
        "overlay-opacity": "0.2",
        "no-dismiss": ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("h3", _hoisted_11, "Her kan du se og rediger information for " + _toDisplayString(_ctx.selectedLandsHoldPlayer.landshold_navn), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_va_button, {
            color: "success",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateSelectedLandsHoldPlayer())),
            disabled: _ctx.isUpdateDissable
          }, {
            default: _withCtx(() => [
              _hoisted_27
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_va_button, {
            color: "secondary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.editLandsholdModal = false, _ctx.selectedLandsHoldPlayer = null, _ctx.landsHoldPlayerEditPayload = {}))
          }, {
            default: _withCtx(() => [
              _hoisted_28
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_va_input, {
                    class: "item",
                    modelValue: _ctx.landsHoldPlayerEdit.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.landsHoldPlayerEdit.name) = $event)),
                    type: "text",
                    label: "Playername",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_va_input, {
                    class: "item",
                    modelValue: _ctx.landsHoldPlayerEdit.club,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.landsHoldPlayerEdit.club) = $event)),
                    type: "text",
                    label: "Clubname",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_va_input, {
                    class: "item",
                    modelValue: _ctx.landsHoldPlayerEdit.pile,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.landsHoldPlayerEdit.pile) = $event)),
                    type: "text",
                    label: "Pile",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.landsHoldPlayerEdit.startDate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.landsHoldPlayerEdit.startDate) = $event)),
                    type: "date",
                    label: "StartDate",
                    max: _ctx.landsHoldPlayer.startDate,
                    bordered: ""
                  }, null, 8, ["modelValue", "max"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.landsHoldPlayerEdit.playerType,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.landsHoldPlayerEdit.playerType) = $event)),
                    label: "playerType",
                    options: _ctx.playerTypeOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.landsHoldPlayerEdit.category,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.landsHoldPlayerEdit.category) = $event)),
                    label: "Category",
                    options: _ctx.playerCategoryOptions,
                    bordered: ""
                  }, null, 8, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", null, [
                  (_ctx.landsHoldPlayerEdit.imageUrl !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("img", {
                          src: _ctx.imageUrl + _ctx.landsHoldPlayerEdit?.imageUrl,
                          width: "250",
                          height: "250"
                        }, null, 8, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    (_ctx.landsHoldPlayerEdit.imageUrl === '')
                      ? (_openBlock(), _createBlock(_component_va_button, {
                          key: 0,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.imageModal = !_ctx.imageModal))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_va_button, {
                          key: 1,
                          color: "secondary",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedLandsHoldImage = '', _ctx.landsHoldPlayerEdit.imageUrl = ''))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_component_va_modal, {
            modelValue: _ctx.imageModal,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.imageModal) = $event)),
            title: "Vælg landsholdbillede",
            size: "large",
            "hide-default-actions": "",
            "overlay-opacity": "0.5"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_va_button, {
                class: "mr-4",
                color: "success",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.useSelectedImageEdit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              }),
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$Message.warning({ text: 'Intet billede valgt' }), (_ctx.imageModal = false), _ctx.cancelImage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOnlyImages(), (media, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "imageContainer",
                      key: index
                    }, [
                      _createElementVNode("label", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.selectedLandsHoldImage) = $event)),
                          class: "sponsorRadio",
                          type: "radio",
                          name: "choosenImage",
                          value: media
                        }, null, 8, _hoisted_32), [
                          [_vModelRadio, _ctx.selectedLandsHoldImage]
                        ]),
                        _createElementVNode("img", {
                          src: _ctx.imageUrl + media.url,
                          width: "150",
                          height: "150"
                        }, null, 8, _hoisted_33)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_vShow, _ctx.tabValue === 'Vis og rediger landshold']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_va_form, {
                  ref: "form",
                  id: "newlandsholdplayer",
                  onSubmit: _ctx.AddPlayerInLandsHold
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_va_input, {
                            class: "item",
                            modelValue: _ctx.landsHoldPlayer.name,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.landsHoldPlayer.name) = $event)),
                            type: "text",
                            label: "Playername",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_va_input, {
                            class: "item",
                            modelValue: _ctx.landsHoldPlayer.club,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.landsHoldPlayer.club) = $event)),
                            type: "text",
                            label: "Clubname",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_va_input, {
                            class: "item",
                            modelValue: _ctx.landsHoldPlayer.pile,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.landsHoldPlayer.pile) = $event)),
                            type: "text",
                            label: "Pile",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_va_input, {
                            modelValue: _ctx.landsHoldPlayer.startDate,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.landsHoldPlayer.startDate) = $event)),
                            type: "date",
                            label: "StartDate",
                            max: _ctx.landsHoldPlayer.startDate,
                            bordered: ""
                          }, null, 8, ["modelValue", "max"])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_va_select, {
                            modelValue: _ctx.landsHoldPlayer.playerType,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.landsHoldPlayer.playerType) = $event)),
                            label: "playerType",
                            options: _ctx.playerTypeOptions,
                            bordered: ""
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _createVNode(_component_va_select, {
                            modelValue: _ctx.landsHoldPlayer.category,
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.landsHoldPlayer.category) = $event)),
                            label: "Category",
                            options: _ctx.playerCategoryOptions,
                            bordered: ""
                          }, null, 8, ["modelValue", "options"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", null, [
                          (_ctx.selectedLandsHoldImage !== '')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                _createElementVNode("img", {
                                  src: _ctx.imageUrl + _ctx.selectedLandsHoldImage.url,
                                  width: "250",
                                  height: "250"
                                }, null, 8, _hoisted_51)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_52, [
                            (_ctx.selectedLandsHoldImage === '')
                              ? (_openBlock(), _createBlock(_component_va_button, {
                                  key: 0,
                                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.imageModal = !_ctx.imageModal))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_53
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_va_button, {
                                  key: 1,
                                  color: "secondary",
                                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedLandsHoldImage = '', _ctx.landsHoldPlayer.imageUrl = ''))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_54
                                  ]),
                                  _: 1
                                }))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (_ctx.loadingStatus)
                            ? (_openBlock(), _createBlock(_component_LoadingButton, {
                                key: 0,
                                color: "success",
                                size: "large"
                              }))
                            : (_openBlock(), _createBlock(_component_va_button, {
                                key: 1,
                                class: "btn",
                                color: "success",
                                size: "large",
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.AddPlayerInLandsHold())),
                                disabled: _ctx.isDissable
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              }, 8, ["disabled"]))
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.imageModal,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.imageModal) = $event)),
          title: "Vælg landsholdbillede",
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.useSelectedImage()))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.$Message.warning({ text: 'Intet billede valgt' }), (_ctx.imageModal = false), _ctx.cancelImage()))
            }, {
              default: _withCtx(() => [
                _hoisted_67
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOnlyImages(), (media, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "imageContainer",
                    key: index
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedLandsHoldImage) = $event)),
                        class: "sponsorRadio",
                        type: "radio",
                        name: "choosenImage",
                        value: media
                      }, null, 8, _hoisted_61), [
                        [_vModelRadio, _ctx.selectedLandsHoldImage]
                      ]),
                      _createElementVNode("img", {
                        src: _ctx.imageUrl + media.url,
                        width: "150",
                        height: "150"
                      }, null, 8, _hoisted_62)
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode(_component_va_divider),
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _createVNode(_component_va_input, {
                  class: "mb-4",
                  type: "file",
                  onChange: _ctx.onFileSelected
                }, null, 8, ["onChange"]),
                _createVNode(_component_va_button, {
                  class: "btn",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onUpload()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_65
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ], 512), [
      [_vShow, _ctx.tabValue === 'Opret ny landshold']
    ])
  ]))
}